import type { AnalyticsEvent, AnalyticsProperties, AnalyticsSink } from './analytics.types';

/**
 * Abstraction neutre : aucun Meta Pixel, GA4 ou autre service n'est branché ici.
 * Un sink concret devra être fourni explicitement par la configuration.
 */
class ConsoleSink implements AnalyticsSink {
  track(event: AnalyticsEvent, properties?: AnalyticsProperties): void {
    if (import.meta.env.DEV) {
      console.debug('[analytics]', event, properties ?? {});
    }
  }
}

let sink: AnalyticsSink = new ConsoleSink();

export function setAnalyticsSink(next: AnalyticsSink): void {
  sink = next;
}

export function track(event: AnalyticsEvent, properties?: AnalyticsProperties): void {
  try {
    sink.track(event, properties);
  } catch {
    // La mesure ne doit jamais interrompre la visite.
  }
}
